<template>
  <div class="body-mobile">
    <div class="wrapper-body">
      <div class="wrapper-body__header">
        <nav-step :active="2"></nav-step>
      </div>
      <div class="wrapper-body__body">
        <div class="wrapper-body__body__title">
          <p>开始{{sysName}}</p>
        </div>
        <div class="wrapper-body__body__container">
          <md-field>
            <!--<md-field-item title="" solid v-if="studentType===2">
              <md-radio :name="1" v-model="studentApplyType" label="材料办理" inline />
              <md-radio :name="2" v-model="studentApplyType" label="积分办理" inline />
            </md-field-item>-->
            <md-input-item
              v-model="studentName"
              :title="studentTypeName+'姓名'"
              placeholder="请输入姓名"
              is-amount
              :maxlength="30"
            ></md-input-item>
            <md-input-item
              v-model="idCard"
              title="身份证号"
              :placeholder="'请输入'+studentTypeName+'身份证号'"
              is-amount
              :maxlength="18"
            ></md-input-item>
            <!-- <md-input-item
              v-if="studentType === 1"
              v-model="guardianMobile"
              title="手机号码"
              :placeholder="'请输入手机号码'"
              is-amount
              :maxlength="18"
            ></md-input-item> -->
          </md-field>
        </div>
      </div>
      <div class="wrapper-body__footer">
        <div class="box-btns">
          <span class="button-primary" @click="handlePreviousStep">上一步</span>
          <span class="button-primary-inset" @click="handleNextStep">下一步</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
	import PageBmLogin from '../index/mixins/page_bm_login';

  export default {
    mixins: [IndexCommon, MobileCommon, PageBmLogin],
    components: {},
    data() {
      return {
        studentApplyType: 1,
        studentName: '',
        idCard: '',
        guardianMobile: ''
      }
		},
		mounted() {
      try {
        let form = JSON.parse(sessionStorage.getItem('signupMobileForm'));
        if (form) {
          for (let item of ['studentApplyType', 'studentName', 'idCard', 'guardianMobile']) {
            if (typeof form[item] !== 'undefined') {
              this[item] = form[item];
            }
          }
        }
      } catch (e) {
        console.warn('-> 从sessionStorag中获取signupMobileForm错误', e);
      }
		},
    methods: {
      handleNextStep() {
        if (this.studentType === 2 && !this.studentApplyType) {
          this.$message.error('必须选择办理类型！');
        } else if (!this.studentName) {
          this.$message.error('姓名不能为空！');
        // } else if (!/^[\u4E00-\u9FA5]{2,10}$/.test(this.studentName)) {
        //   this.$message.error('姓名格式错误！');
        } else if (!this.idCard) {
          this.$message.error('身份证号不能为空！');
        } else if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.idCard)) {
          this.$message.error('身份证号格式错误！');
        // } else if (this.studentType === 1 && !this.guardianMobile) {
        //   this.$message.error('手机号码不能为空！');
        } else {
          console.log('-> handleNextStep success', this.studentApplyType);
          let formVal = {
            studentName: this.studentName,
            idCard: this.idCard
          };
          if (this.studentApplyType) formVal['studentApplyType'] = this.studentApplyType;
          if (this.guardianMobile) formVal['guardianMobile'] = this.guardianMobile;

          // debug 暂时写死
          // this.ajaxCheckIdCard({
          //   signupNoticeId: this.signupNoticeId,
          //   idCard: '510521201709090001'
          // }, {
          //   studentApplyType: 1,
          //   studentName: '王一先',
          //   idCard: '510521201709090001'
          // });

          // todo
          this.ajaxCheckIdCard({
            signupNoticeId: this.signupNoticeId,
            idCard: this.idCard
          }, formVal);
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  // 设置固定高度
  .wrapper-body
    // bottom 3rem
    height 980px
</style>
